// src/store/reducers/profileSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { base_url } from '../../utils/config';

export const fetchProfile = createAsyncThunk(
  'profile/fetch',
  async (_, { getState, rejectWithValue }) => {
    const token = getState().auth.token;
    try {
      const { data } = await axios.get(
        `${base_url}/api/dashboard/customer/profile`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return data.user;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: 'Fetch failed' });
    }
  }
);

export const updateProfile = createAsyncThunk(
  'profile/update',
  async (updates, { getState, rejectWithValue }) => {
    const token = getState().auth.token;
    try {
      const { data } = await axios.put(
        `${base_url}/api/dashboard/customer/profile`,
        updates,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return data.user;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: 'Update failed' });
    }
  }
);

const slice = createSlice({
  name: 'profile',
  initialState: {
    user: null,
    status: 'idle',
    error: null,
    updateStatus: 'idle',
    updateError: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      // FETCH
      .addCase(fetchProfile.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchProfile.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.user = payload;
      })
      .addCase(fetchProfile.rejected, (state, { payload }) => {
        state.status = 'failed';
        state.error = payload.error;
      })
      // UPDATE
      .addCase(updateProfile.pending, state => {
        state.updateStatus = 'loading';
      })
      .addCase(updateProfile.fulfilled, (state, { payload }) => {
        state.updateStatus = 'succeeded';
        state.user = payload;
      })
      .addCase(updateProfile.rejected, (state, { payload }) => {
        state.updateStatus = 'failed';
        state.updateError = payload.error;
      });
  }
});

export default slice.reducer;
